import SpainProfessionalCategory from 'modules/contracts/store/models/SpainProfessionalCategory'

import { PayrollLegalEntityResource } from '../payrollLegalEntityResource'

class ProfessionalCategories extends PayrollLegalEntityResource<SpainProfessionalCategory> {
  get cacheKey(): string {
    return 'spainProfessionalCategories'
  }

  model() {
    return SpainProfessionalCategory
  }
}

export { ProfessionalCategories }
